import { render, staticRenderFns } from "./GoodsTypes.vue?vue&type=template&id=b05cbd48&scoped=true&"
import script from "./GoodsTypes.vue?vue&type=script&lang=js&"
export * from "./GoodsTypes.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTypes.vue?vue&type=style&index=0&id=b05cbd48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05cbd48",
  null
  
)

/* custom blocks */
import block0 from "./GoodsTypes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports